import React from 'react';
import {
  IRowMeta,
  RowType,
  addNewRowAction,
  addSimpleCohort,
} from '../../../redux/slices/oldBuilder';
import styled from 'styled-components';
import { PickEnum } from '../../../utils/types';
import { useAppDispatch } from '../../../redux/hooks';
import {
  addQueryMeasureTooltip,
  ITooltipOption,
} from '../../KubitTooltip/globalTooltips';
import { SecondaryButton } from '../../Button';
import { IButtonAnalyticsProps } from '../../Button/types';
import KubitTooltip from '../../KubitTooltip';
import { IS_SCREENSHOT_MODE } from '../../../config/constants';

type AllowedAddRowTypes = PickEnum<
  RowType,
  | RowType.measures
  | RowType.builderCohorts
  | RowType.steps
  | RowType.dataTableMeasures
>;

const builderAddRowTooltips: Record<AllowedAddRowTypes, ITooltipOption> = {
  [RowType.measures]: addQueryMeasureTooltip,
  [RowType.steps]: {
    content: 'Add an additional step',
  },
  [RowType.dataTableMeasures]: { content: 'Add an additional measure' },
  [RowType.builderCohorts]: { content: 'Add an additional cohort' },
};

interface IProps extends IButtonAnalyticsProps {
  rowMeta: IRowMeta & { rowType: AllowedAddRowTypes };
  label: string;
  onClick?: (rowMeta: IRowMeta) => void;
}

const Container = styled.div`
  text-align: center;
`;

/**
 * This component is used for adding new rows to the builder: query, funnel, data table and cohort sample page.
 */
export default ({
  rowMeta,
  onClick,
  label,
  trackAction,
  trackContext,
}: IProps) => {
  const { rowType } = rowMeta;
  const dispatch = useAppDispatch();
  const onClickHandler = () => {
    if (onClick) {
      onClick(rowMeta);
    }

    if (rowType === RowType.builderCohorts) {
      dispatch(addSimpleCohort(rowMeta));
      return;
    }

    dispatch(addNewRowAction({ rowMeta }));
  };

  if (IS_SCREENSHOT_MODE) {
    return null;
  }

  return (
    <Container>
      <KubitTooltip {...builderAddRowTooltips[rowType]} placement="bottom">
        <SecondaryButton
          onClick={onClickHandler}
          isOutlined={true}
          trackAction={trackAction}
          trackContext={trackContext}
        >
          {label}
        </SecondaryButton>
      </KubitTooltip>
    </Container>
  );
};
